<app-nav></app-nav>
<div class="content-height">
  <router-outlet style="width: 100%"></router-outlet>

  <app-modal-dialog></app-modal-dialog>
</div>
